import { render, staticRenderFns } from "./PartnerVoucherList.vue?vue&type=template&id=282fbb58&scoped=true"
import script from "./PartnerVoucherList.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerVoucherList.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/assets/scss/category/ticket.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PartnerVoucherList.vue?vue&type=style&index=1&id=282fbb58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fbb58",
  null
  
)

export default component.exports